export default "__VITE_ASSET__BYs6JM9i__"